import styled from 'styled-components'
import {H3, Highlight} from '@modifi/ui'

export const Header = styled.header`
  margin: 40px 0;
  text-align: center;
  position: relative;

  ${H3} {
    margin: 0;
  }
`

export const StyledHighlight = styled(Highlight)`
  margin: 0 0 10px;
`

export const Wrapper = styled.div`
  overflow-x: scroll;
`
